import { useSearchParams } from 'react-router-dom';

import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { PresentationTemplateEditor } from '@/modules/presentationTemplates/PresentationTemplateEditor/PresentationTemplateEditor';
import { ROUTE_KEYS } from '@/navigation/constants';
import { PresentationTemplateType } from '@/types/schema';

export function AdminPresentationTemplateEditorPage() {
  const templateId = useRequiredParam('templateId');
  const [searchParams] = useSearchParams();
  // Set when opening a read-only system template, so the editor only offers
  // "Save as new template" rather than updating the source in place.
  const isDuplicateFlow = searchParams.get('isDuplicateFlow') === 'true';
  const { navigate } = useNavigateToRoute();
  return (
    <PresentationTemplateEditor
      templateId={templateId}
      isDuplicateFlow={isDuplicateFlow}
      onClose={() => navigate(ROUTE_KEYS.ADMIN_PRESENTATION_TEMPLATES, {})}
      createTemplateType={PresentationTemplateType.TenantTemplate}
    />
  );
}
